import { Feedback } from '../../models';
import { FeedbackService } from '../../services';
import ActionType from './types';

export const AddFeedback = (feedback: Feedback) => ({
  type: ActionType.ADD_FEEDBACK,
  payload: FeedbackService.addFeedback(feedback),
});
